<template>
  <div>
    <div class="m-b-5 ovf-hd">
      <!-- <div class="fl m-r-30" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加用户
        </router-link>
      </div> -->
      <div class="fl w-400">
        <el-input placeholder="请输入报销人/报销消费事由/备注/票据类型" clearable v-model="keywords">
          <el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
        </el-input>
      </div><span class="m-l-30" style="color:#111;">企业：<span style="font-size:20px;font-weight:700;margin-top:7px;color:#111;">{{company_name}}</span></span>
    </div>
    <el-table
    :data="tableData"
    :height="setHeight.page_height"
    style="width: 100%"
    border
    @selection-change="selectItem">
      <el-table-column
      type="selection"
      width="50">
      </el-table-column>
      <el-table-column
      prop="id"
      label="ID">
      </el-table-column>
      <!-- <el-table-column
      prop="user_head"
      label="头像">
        <template scope="scope">
          <el-popover
            v-if="scope.row.user_head"
            placement="right-end"
            width="400"
            trigger="click">
            <img :src="scope.row.user_head" width="100%">
            <img :src="scope.row.user_head" width="50" height="50" slot="reference">
          </el-popover>
        </template>
      </el-table-column> -->
      <el-table-column
      prop="user_name"
      label="报销人">
      </el-table-column>
      <el-table-column
      prop="reason"
      label="报销事由"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="consume_money"
      label="报销金额">
      </el-table-column>
      <el-table-column
      label="报销状态">
        <template scope="scope">
          <div>
            <span v-if = "scope.row.status ==-1">删除</span>
            <span v-if = "scope.row.status ==0">保存</span>
            <span v-if = "scope.row.status ==1">待审批</span>
            <span v-if = "scope.row.status ==2">待审核</span>
            <span v-if = "scope.row.status ==3">待核销</span>
            <span v-if = "scope.row.status ==4">已驳回</span>
            <span v-if = "scope.row.status ==5">待支付</span>
            <span v-if = "scope.row.status ==6">已完成</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
      prop="cost"
      label="票据类型">
      </el-table-column>
      <el-table-column
      prop="consume_time"
      label="消费时间">
      </el-table-column>
      <el-table-column
      prop="consume_reason"
      label="消费事由"
      :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
      prop="create_time"
      label="申请时间">
      </el-table-column>
      <el-table-column
      prop="remarks"
      label="备注"
      :show-overflow-tooltip="true">
      </el-table-column>
      <!-- <el-table-column
      prop="bill_url"
      label="发票">
        <template scope="scope">
          <el-popover
            v-if="scope.row.bill_url"
            placement="right-end"
            width="400"
            trigger="click">
            <img :src="scope.row.bill_url" width="100%">
            <img :src="scope.row.bill_url" width="50" height="50" slot="reference">
          </el-popover>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="pos-rel p-t-20">
      <!-- <btnGroup :selectedData="multipleSelection" :type="'bill'"></btnGroup> -->
      <div class="block pages">
        <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :page-size="limit"
        :current-page="currentPage"
        :total="dataCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import btnGroup from '../../../Common/btn-bill-group.vue'
  import http from '../../../../assets/js/http'

  export default {
    data() {
      return {
        showbtn: false,
        tableData: [],
        dataCount: null,
        currentPage: null,
        company_name: '',
        keywords: '',
        multipleSelection: [],
        limit: 15
      }
    },
    methods: {
      search() {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: 1 }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ path: this.$route.path, query: { keywords: this.keywords, page: page }})
      },
      getAllUsers() {
        this.loading = true
        const data = {
          params: {
            id: this.$route.params.id,
            keywords: this.keywords,
            page: this.currentPage,
            limit: this.limit
          }
        }
        this.apiGet('admin/company/company_bill', data).then((res) => {
          // console.log('res = ', _g.j2s(res))
          this.handelResponse(res, (data) => {
            this.company_name = data.company_name
            this.tableData = data.list
            this.dataCount = data.dataCount
          })
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllUsers()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('company-save')
      },
      editShow() {
        return _g.getHasRule('company-update')
      },
      deleteShow() {
        return _g.getHasRule('company-delete')
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// company_bill.vue?1d07420d